import TypeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';

import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import { SET_LISTS, GET_ROLES_LIST, GET_PERMISSIONS_LIST } from 'containers/lists/constants';

const initialState = {
  isLoading: false,
  entities: {},
  result: {},
  permissions: [],
};

const account = new schema.Entity('accounts');
const costCenter = new schema.Entity('costCenters');
const element = new schema.Entity('element');
const employee = new schema.Entity('employees');
const location = new schema.Entity('locations');
const project = new schema.Entity('projects');
const provider = new schema.Entity('providers');
const depreciation = new schema.Entity('depreciations');
const asset_level = new schema.Entity('asset_level');
const role = new schema.Entity('roles');

const setLists = (state, { payload }) => {
  const lists = {
    accounts: [account],
    costCenters: [costCenter],
    employees: [employee],
    locations: [location],
    projects: [project],
    providers: [provider],
    depreciations: [depreciation],
    asset_levels: [asset_level],
    catalogs: {
      buyCondition: [element],
      coin: [element],
      country: [element],
      insuranceCarrier: [element],
      physicalState: [element],
      status: [element],
      disableReason: [element],
      prefix: [element],
      customsDocumentsStatus: [element],
    },
  };

  const normalized = normalize(payload, lists);

  return {
    ...state,
    isLoading: false,
    entities: {
      ...state.entities,
      ...normalized.entities,
      inpcs: payload.inpcs,
    },
    result: { ...state.result, ...normalized.result },
  };
};

const getRolesListPending = (state, action) => ({ ...state, isLoading: true });

const getRolesListRejected = (state, action) => ({
  ...state,
  isLoading: false,
});

const getRolesListFulfilled = (state, { payload: { roles } }) => ({
  ...state,
  isLoading: false,
  ...normalize({ roles }, { roles: [role] }),
});

const getPermissionsListPending = (state, action) => ({
  ...state,
  isLoading: true,
});
const getPermissionsListRejected = (state, action) => ({
  ...state,
  isLoading: false,
});
const getPermissionsListFulfilled = (state, { payload: { permissions } }) => ({
  ...state,
  isLoading: false,
  permissions,
});

const listReducers = {
  [SET_LISTS]: setLists,
  [GET_ROLES_LIST]: {
    [PENDING]: getRolesListPending,
    [REJECTED]: getRolesListRejected,
    [FULFILLED]: getRolesListFulfilled,
  },
  [GET_PERMISSIONS_LIST]: {
    [PENDING]: getPermissionsListPending,
    [REJECTED]: getPermissionsListRejected,
    [FULFILLED]: getPermissionsListFulfilled,
  },
};

export default TypeToReducer(listReducers, initialState);



// WEBPACK FOOTER //
// src/containers/lists/reducers-new.js